import React from 'react';
import { Container } from '@material-ui/core';
import TraitCategory from './debug-page/TraitCategory';
import AfterPage from './debug-page/Manager';

const DebugPage = () => {
  return (
    <Container>
      <TraitCategory />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <AfterPage />
    </Container>
  );
};

export default DebugPage;
